export function clamp(value: number, min: number, max: number) {
    return Math.min(Math.max(value, min), max)
}

/**
 * Generates an integer between 0 (including) and max (including)
 * @param max: number;
 * @returns number;
 */
export function generateRandomNumber(max: number): number;
/**
 * Generates an integer between min (including) and max (including)
 * @param min: number;
 * @param max: number;
 * @returns number;
 */
export function generateRandomNumber(min: number ,max: number): number;

/* implementation here */
export function generateRandomNumber(limit1: number, limit2?: number) {
    let min: number, max: number;
    if (limit2 && !isNaN(limit2)) {
        min = limit1;
        max = limit2;
    } else {
        min = 0;
        max = limit1;
    }
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
